import { seoContent } from '@/mocks/content';

const featureImages = [
  'https://readdy.ai/api/search-image?query=Cluttered%20messy%20desk%20with%20scattered%20papers%20and%20multiple%20browser%20tabs%20on%20laptop%2C%20frustrating%20manual%20search%20concept%2C%20warm%20dim%20lighting%2C%20chaotic%20workspace%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography%2C%20overwhelmed%20atmosphere&width=600&height=640&seq=feat-v2-search&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Ultra%20organized%20minimal%20workspace%20with%20single%20laptop%20showing%20colorful%20spreadsheet%2C%20small%20plant%2C%20bright%20natural%20window%20light%2C%20calm%20productive%20atmosphere%2C%20cream%20walls%2C%20warm%20neutral%20aesthetic%2C%20editorial%20photography%2C%20zen%20minimalism&width=600&height=640&seq=feat-v2-sheet&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Expensive%20shopping%20cart%20on%20laptop%20screen%20with%20high%20total%2C%20worried%20shopper%20concept%2C%20soft%20overhead%20lighting%2C%20cream%20desk%20setup%2C%20warm%20neutral%20palette%2C%20editorial%20photography%2C%20uncertainty%20and%20risk%20theme%2C%20minimal%20composition&width=600&height=640&seq=feat-v2-direct&orientation=landscape'
];

export default function FeatureComparison() {
  return (
    <section id="guia" className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-14 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-900">
            {seoContent.featureTitle} <span className="text-accent-500">{seoContent.featureTitleHighlight}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {seoContent.featureCards.map((card, idx) => (
            <div
              key={idx}
              className={`relative rounded-2xl overflow-hidden group cursor-pointer transition-all duration-300 ${
                card.featured
                  ? 'md:scale-105 ring-2 ring-accent-400'
                  : 'hover:scale-[1.02]'
              }`}
            >
              <div className="relative w-full h-72 md:h-80 overflow-hidden">
                <img
                  src={featureImages[idx]}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-white text-lg md:text-xl font-semibold mb-2">
                  {card.title}
                </h3>
                <p className="text-white/75 text-xs md:text-sm leading-relaxed">
                  {card.description}
                </p>
              </div>
              {card.featured && (
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  MELHOR OPÇÃO
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}